import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ContainerOffHireService } from '../container-off-hire.service';
import { ValidateOffHireContainerComponent } from '../validate-off-hire-container/validate-off-hire-container.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ContainerOffHireClass } from '../container-off-hire';
import {GlobalLoaderService} from "../../../services/global-loader.service";

@Component({
  selector: 'logzy-container-off-hire',
  templateUrl: './container-off-hire.component.html',
  styleUrls: ['./container-off-hire.component.scss']
})
export class ContainerOffHireComponent implements OnInit {
  pageLength = 0;
  pageSize = 10;
  pageIndex = 0;
  update: boolean = false;
  containerList: MatTableDataSource<any>;
  displayedColumns: string[] = ['container_number', 'size_type', 'mnr_status', 'booking_ref', 'off_hire_date', 'off_hire_location', 'off_hire_remarks','off_hire_by'];
  errorObj: any = {};
  container_numbers: any
  containerOffhireObject: ContainerOffHireClass;
  loading: boolean = true;
  constructor(private containerOffHireService: ContainerOffHireService, private dialog: MatDialog,
    private snackBar: MatSnackBar, private router: Router,private loaderService: GlobalLoaderService
  ) { }

  ngOnInit(): void {
    this.containerOffhireObject = new ContainerOffHireClass();
    // this.containerOffHireList();
  }
  containerOffHireList(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
    pageSize = pageSize || this.pageSize;
    pageIndex = pageIndex || this.pageIndex
    this.containerOffHireService.getAllContainerList(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
      next: response => {
        this.containerList = new MatTableDataSource(response.results);
        this.pageLength = response.count;
        this.loading = false;
        this.update = false;
      }
    })
  }

  /** Announce the change in sort state for assistive technology. */
  announceSortChange(sortState: Sort) {
    this.update = true;
    switch (sortState.direction) {
      case 'asc':
        this.containerOffHireList(this.pageSize, this.pageIndex, '', sortState.active);
        break;

      case 'desc':
        this.containerOffHireList(this.pageSize, this.pageIndex, '', `-${sortState.active}`);
        break;

      default:
        this.containerOffHireList(this.pageSize, this.pageIndex);
    }
  }
  pageChanged(event: PageEvent) {
    this.update = true;
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.containerOffHireList();
  }
  containerListResponse: any;
  validateContainers() {
    this.loaderService.showLoader();
    const splitArray = this.containerOffhireObject['container_numbers'].split(/[,\n\s]+/);
    const uniqueArray = Array.from(new Set(splitArray));
    this.containerOffhireObject['container_numbers'] = uniqueArray.join(", ");
    this.containerOffHireService.postValidateContainer(this.containerOffhireObject).subscribe({
      next: response => {
        // this.containerList = new MatTableDataSource(response);
        this.containerListResponse = response;
        this.loaderService.hideLoader();
        this.openDialog();
      },
      error: error => {
        this.loaderService.hideLoader();
        return this.catchError(error);
      }
    })
  }

  openDialog(): void {
    const dialogData = {
      data: this.containerListResponse,
      containerOffhireObject: this.containerOffhireObject

    };
    const dialogRef = this.dialog.open(ValidateOffHireContainerComponent, {
      panelClass:'testing',
      width: '100%', // Set the width of the dialog
      disableClose: true,
      data: dialogData
    });

    // Optionally, you can subscribe to dialog close events
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      } else {
      }
    });

    dialogRef.componentInstance.offHiredContainerSaved.subscribe((updatedData: any) => {
      console.log("updatedData", updatedData)
      if (updatedData) {
        this.containerList = new MatTableDataSource(updatedData);
        this.snackBar.open("Container Off-Hire Successfully!", 'Close', {
          verticalPosition: 'top',
          duration: 2000,
        });
        this.containerOffhireObject = new ContainerOffHireClass();
      }

    });
  }

  closeDetails() {
    this.router.navigateByUrl(`dashboards/dashboard1`);
  }
  // Function to catch errors
  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug("error object", this.errorObj);
      return error;
    }
  }
}
